import { render, staticRenderFns } from "./ModuleDateTimeForm.vue?vue&type=template&id=205ce806&scoped=true"
import script from "./ModuleDateTimeForm.vue?vue&type=script&lang=js"
export * from "./ModuleDateTimeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205ce806",
  null
  
)

export default component.exports